import { frArticles, enArticles } from "./blogArticles";

export const fr = {
  video: {
    label: "Notre Vision",
    heading: "Transformer l\u2019industrie lourde en organisations performantes et durables.",
    pause: "Pause",
    play: "Lecture",
  },
  nav: {
    links: [
      { label: "Services", id: "services" },
      { label: "Approche", id: "methodology" },
      { label: "R\u00e9sultats", id: "results" },
      { label: "\u00c0 propos", id: "about" },
      { label: "IA", id: "ai-transformation" },
      { label: "Contact", id: "contact" },
    ],
    bookCall: "R\u00e9server un appel",
  },
  hero: {
    est: "Fond\u00e9 en 2010, Londres, Royaume-Uni",
    h1: ["Transformer les ", "Op\u00e9rations", "Industrielles", " en", "R\u00e9sultats Durables"],
    tagline: "L'excellence op\u00e9rationnelle par la transformation digitale",
    subtitle: "Nous livrons des r\u00e9sultats qui durent. En partenariat avec les leaders industriels mondiaux pour mettre en \u0153uvre des changements durables \u00e0 travers les op\u00e9rations, les syst\u00e8mes num\u00e9riques et les comp\u00e9tences organisationnelles.",
    ctaExplore: "D\u00e9couvrir nos services",
    ctaBook: "R\u00e9server un appel",
    trustClients: ["ArcelorMittal", "Glencore", "Aperam", "DHL", "Yamama Cement"],
    moreSectors: "& d\u2019autres leaders industriels",
    scroll: "D\u00e9filer",
  },
  stats: [
    { value: "2010", label: "Ann\u00e9e de cr\u00e9ation", suffix: "" },
    { value: "20", label: "Ann\u00e9es d\u2019impact", suffix: "+" },
    { value: "50", label: "Programmes de transformation", suffix: "+" },
    { value: "12", label: "Pays d\u2019intervention", suffix: "+" },
  ],
  services: {
    label: "Notre Expertise",
    heading: "Sept domaines de comp\u00e9tences int\u00e9gr\u00e9s",
    desc: "Une expertise industrielle approfondie, du conseil en transformation et de l\u2019innovation num\u00e9rique, incluant une pratique d\u00e9di\u00e9e \u00e0 la Transformation par l\u2019IA.",
    expandLabel: "En savoir plus",
    collapseLabel: "R\u00e9duire",
    items: [
      {
        title: "Transformation Op\u00e9rationnelle & Am\u00e9lioration de la Performance",
        subtitle: "Excellence Op\u00e9rationnelle",
        description: "Accompagner les organisations industrielles dans l\u2019am\u00e9lioration de la productivit\u00e9, la r\u00e9duction des co\u00fbts et la discipline op\u00e9rationnelle \u00e0 travers des programmes de transformation structur\u00e9s.",
        points: ["Syst\u00e8mes de management op\u00e9rationnel (MOS)", "Cadres de pilotage et de suivi de la performance", "Excellence op\u00e9rationnelle & am\u00e9lioration continue", "R\u00e9duction des co\u00fbts & am\u00e9lioration de la productivit\u00e9"],
      },
      {
        title: "Transformation Num\u00e9rique & Adoption de l\u2019IA",
        subtitle: "Num\u00e9rique & IA",
        description: "Accompagner les organisations dans l\u2019int\u00e9gration des technologies num\u00e9riques au sein des op\u00e9rations et de la prise de d\u00e9cision. L\u2019objectif est de cr\u00e9er de la valeur m\u00e9tier gr\u00e2ce \u00e0 la technologie, et non l\u2019inverse.",
        points: ["Identification d\u2019opportunit\u00e9s d\u2019automatisation \u00e0 forte valeur ajout\u00e9e", "Am\u00e9lioration des processus par l\u2019IA", "Mod\u00e8les op\u00e9rationnels num\u00e9riques", "Pilotage de la performance par les donn\u00e9es"],
      },
      {
        title: "Ex\u00e9cution Strat\u00e9gique & Leadership de Transformation",
        subtitle: "Mise en \u0152uvre Strat\u00e9gique",
        description: "Aider les organisations \u00e0 traduire leur strat\u00e9gie en programmes de transformation structur\u00e9s, avec une gouvernance claire et des r\u00e9sultats mesurables.",
        points: ["Feuilles de route de transformation strat\u00e9gique", "Gouvernance & pilotage de programmes", "Leadership de transformation transversale", "Conduite du changement \u00e0 grande \u00e9chelle"],
      },
      {
        title: "Op\u00e9rations Industrielles & Excellence en Fiabilit\u00e9",
        subtitle: "Expertise Industrielle",
        description: "Accompagnement sp\u00e9cialis\u00e9 pour les industries \u00e0 forte intensit\u00e9 d\u2019actifs, ax\u00e9 sur l\u2019am\u00e9lioration du TRS, la fiabilit\u00e9 de la maintenance et l\u2019optimisation des syst\u00e8mes de production.",
        points: ["Programmes d\u2019am\u00e9lioration du TRS", "Strat\u00e9gies de fiabilit\u00e9 de la maintenance", "Optimisation des syst\u00e8mes de production", "Cadres de gestion des op\u00e9rations"],
      },
      {
        title: "Design Organisationnel & D\u00e9veloppement du Leadership",
        subtitle: "Organisation & Talents",
        description: "S\u2019assurer que les organisations disposent de la structure, des comp\u00e9tences et de l\u2019alignement du leadership n\u00e9cessaires pour p\u00e9renniser la transformation et g\u00e9n\u00e9rer une performance durable.",
        points: ["Conception de mod\u00e8les op\u00e9rationnels", "Coaching & alignement du leadership", "Programmes de conduite du changement", "D\u00e9veloppement des comp\u00e9tences"],
      },
      {
        title: "PMO & Gouvernance",
        subtitle: "Direction de Programme",
        description: "Mise en place de bureaux de gestion de programme (PMO) et de cadres de gouvernance robustes pour garantir que les initiatives de transformation sont livr\u00e9es dans les d\u00e9lais, dans le budget et avec une responsabilit\u00e9 totale.",
        points: ["Mise en place & structuration de PMO", "Cadres de gouvernance & comit\u00e9s de pilotage", "Priorisation du portefeuille & allocation des ressources", "Gestion des risques & reporting de performance"],
      },
    ],
  },
  ai: {
    label: "Nouvelle comp\u00e9tence",
    heading: "Transformation IA &",
    headingAccent: "Conduite du Changement",
    intro: "Faites de l\u2019IA un avantage concurrentiel. Nous int\u00e9grons des solutions IA sur mesure directement dans vos processus pour am\u00e9liorer l\u2019efficacit\u00e9 et favoriser une prise de d\u00e9cision plus intelligente, en renfor\u00e7ant la confiance des \u00e9quipes dirigeantes et op\u00e9rationnelles, tout en garantissant que chaque initiative se traduise en r\u00e9sultats mesurables.",
    approachIntro: "En combinant vision strat\u00e9gique, expertise op\u00e9rationnelle et mise en \u0153uvre concr\u00e8te, les outils d\u2019IA sont int\u00e9gr\u00e9s dans les processus quotidiens pour que vos \u00e9quipes travaillent plus vite et prennent de meilleures d\u00e9cisions, tout en maintenant des op\u00e9rations stables et efficaces.",
    whyLabel: "Pourquoi c\u2019est important",
    whyPoints: [
      "Identifier et exploiter les opportunit\u00e9s d\u2019automatisation \u00e0 forte valeur ajout\u00e9e",
      "Acc\u00e9l\u00e9rer l\u2019adoption d\u2019outils d\u2019IA modernes pour am\u00e9liorer la productivit\u00e9 et la satisfaction client",
      "Piloter des initiatives de transformation qui renforcent l\u2019efficacit\u00e9 tout en maintenant la stabilit\u00e9 op\u00e9rationnelle",
    ],
    divider: "Ce que nous livrons",
    deliverables: [
      { title: "Identification des opportunit\u00e9s d\u2019automatisation", body: "Nous analysons les processus m\u00e9tier pour identifier o\u00f9 l\u2019automatisation et l\u2019IA peuvent g\u00e9n\u00e9rer le plus d\u2019impact, et priorisons les initiatives selon leur cr\u00e9ation de valeur." },
      { title: "D\u00e9veloppement de preuves de concept IA", body: "Nous concevons et r\u00e9alisons des cas d\u2019usage concrets pour d\u00e9montrer les b\u00e9n\u00e9fices tangibles de l\u2019IA et de l\u2019automatisation, avec des indicateurs de performance clairs." },
      { title: "Transformation transversale", body: "Nous travaillons en \u00e9troite collaboration avec les \u00e9quipes op\u00e9rations, technologie, produit et client pour concevoir et d\u00e9ployer des solutions align\u00e9es sur les objectifs m\u00e9tier." },
      { title: "Adoption de l\u2019IA & mont\u00e9e en comp\u00e9tences", body: "Nous accompagnons les \u00e9quipes dans l\u2019adoption des outils d\u2019IA par la formation, le coaching et un soutien pratique \u00e0 la mise en \u0153uvre." },
      { title: "Leadership de transformation de bout en bout", body: "Nous pilotons des programmes de changement complexes, en assurant l\u2019alignement entre strat\u00e9gie, ex\u00e9cution et performance op\u00e9rationnelle." },
      { title: "Innovation continue & optimisation", body: "Nous suivons l\u2019avancement de la mise en \u0153uvre, affinons les initiatives d\u2019automatisation et int\u00e9grons les \u00e9volutions pertinentes en mati\u00e8re d\u2019IA et de technologies num\u00e9riques." },
    ],
  },
  about: {
    label: "Le Fondateur",
    role: "Fondateur & Directeur G\u00e9n\u00e9ral",
    bio1: "Le Dr. Jaoued Ahmed a fond\u00e9 Advaltis en 2010. Master Black Belt en Excellence Op\u00e9rationnelle, Doctorat d\u2019Oxford et MBA INSEAD, il a dirig\u00e9 des programmes de transformation \u00e0 grande \u00e9chelle dans l\u2019acier, les mines, le p\u00e9trole & gaz et le secteur technologique. Lorsque les missions n\u00e9cessitent une expertise compl\u00e9mentaire, il s\u2019appuie sur un r\u00e9seau s\u00e9lect de Senior Consulting Partners.",
    credentials: [
      { label: "Doctorat en Science des Mat\u00e9riaux", detail: "Universit\u00e9 d\u2019Oxford" },
      { label: "Executive MBA", detail: "INSEAD Business School" },
      { label: "Master Black Belt", detail: "Excellence Op\u00e9rationnelle & Six Sigma" },
      { label: "Expertise Internationale", detail: "Acier, Mines, P\u00e9trole & Gaz, Technologie" },
      { label: "Fondateur d\u2019Advaltis", detail: "2010, Londres, Royaume-Uni" },
    ],
    imageAlt: "Dr. Jaoued Ahmed, Fondateur, Advaltis Consulting",
    overlayLabel: "Advaltis Consulting, Fond\u00e9 en 2010",
    overlayText: "Plus de 20 ans de transformation d\u2019organisations industrielles dans le monde",
    whyLabel: "Pourquoi Advaltis",
    whyHeading: "Expertise industrielle.",
    whyHeadingAccent: "Engagement sur mesure.",
    whyDesc: "Advaltis n\u2019est pas un grand cabinet de conseil traditionnel. Nous sommes un partenaire sp\u00e9cialis\u00e9 qui apporte une expertise de premier plan directement dans vos op\u00e9rations, avec la concentration et l\u2019agilit\u00e9 que les grands cabinets ne peuvent tout simplement pas offrir.",
    whyCta: "Engageons la conversation",
    whyItems: [
      { title: "Rigueur analytique & m\u00e9thodologique", description: "Une combinaison rare de profondeur analytique de niveau doctoral, d\u2019expertise Master Black Belt en Excellence Op\u00e9rationnelle, et d\u2019exp\u00e9rience pratique de transformation dans des environnements industriels complexes." },
      { title: "Expertise industrielle approfondie", description: "Advaltis n\u2019est pas un cabinet g\u00e9n\u00e9raliste, nous apportons des d\u00e9cennies d\u2019expertise cibl\u00e9e dans l\u2019acier, les mines, le p\u00e9trole & gaz et l\u2019industrie lourde, l\u00e0 o\u00f9 les enjeux sont les plus importants." },
      { title: "Impact m\u00e9tier mesurable", description: "Chaque mission est structur\u00e9e autour de r\u00e9sultats quantifiables. Nous d\u00e9finissons les indicateurs de succ\u00e8s en amont et nous nous engageons \u00e0 les atteindre." },
      { title: "Boutique. S\u00e9nior. Engag\u00e9.", description: "Vous travaillez directement avec le Dr. Ahmed, pas avec une \u00e9quipe de consultants juniors. Lorsque les missions n\u00e9cessitent plus de profondeur ou de rapidit\u00e9, il s\u2019appuie sur un r\u00e9seau s\u00e9lect de Senior Consulting Partners." },
      { title: "Partenariats avec des cabinets experts", description: "Advaltis travaille en partenariat strat\u00e9gique avec d\u2019autres cabinets de conseil sp\u00e9cialis\u00e9s, mobilisant l\u2019expertise ad\u00e9quate, coordonn\u00e9e et garantie en qualit\u00e9." },
    ],
  },
  clients: {
    header: "La confiance des leaders industriels mondiaux",
    sectors: ["Acier & M\u00e9taux", "Mines & Ressources", "P\u00e9trole & Gaz", "Ciment & Mat\u00e9riaux", "Logistique & Supply Chain", "Industrie Lourde", "Industrie", "Conseil"],
    items: [
      { name: "ArcelorMittal", sector: "Acier", logo: "/logos/arcelormittal.png" },
      { name: "Glencore", sector: "Mines", logo: "/logos/glencore.png" },
      { name: "Aperam", sector: "Acier", logo: "/logos/aperam.png" },
      { name: "Maghreb Steel", sector: "Acier" },
      { name: "Yamama Cement", sector: "Ciment" },
      { name: "DHL", sector: "Logistique & Supply Chain", logo: "/logos/dhl.png" },
      { name: "North American Steel", sector: "Acier" },
      { name: "CMT", sector: "Mines" },
      { name: "Ingelec", sector: "Industrie" },
      { name: "Proudfoot", sector: "Conseil" },
      { name: "YCP Renoir", sector: "Conseil" },
      { name: "TNP Consultants", sector: "Conseil" },
      { name: "ATPERF Conseil", sector: "Partenaire" },
      { name: "MLK Conseil", sector: "Partenaire" },
      { name: "KAY Consulting", sector: "Partenaire" },
    ],
  },
  caseStudies: {
    label: "Missions Clients",
    heading: "Un impact prouv\u00e9 \u00e0 travers",
    headingAccent: "l\u2019industrie mondiale",
    desc: "Du diagnostic \u00e0 la transformation compl\u00e8te, chaque mission est structur\u00e9e autour de r\u00e9sultats mesurables et durables.",
    challengeLabel: "Le d\u00e9fi",
    approachLabel: "L'approche",
    methodology: [
      { phase: "01", label: "Diagnostic & Analyse", desc: "\u00c9valuation de l\u2019\u00e9tat actuel, identification des \u00e9carts de performance, quantification des leviers d\u2019am\u00e9lioration" },
      { phase: "02", label: "Conception & Feuille de Route", desc: "D\u00e9finition de la cible, feuille de route structur\u00e9e, portefeuille de projets prioris\u00e9s avec une gouvernance claire" },
      { phase: "03", label: "Mise en \u0152uvre du Programme", desc: "D\u00e9ploiement terrain, mise en place du MOS, accompagnement du changement, suivi et pilotage de la performance" },
      { phase: "04", label: "P\u00e9renniser & Transformer", desc: "D\u00e9veloppement des comp\u00e9tences, ancrage de la performance et transformation organisationnelle pour des r\u00e9sultats durables" },
    ],
    items: [
      {
        project: "Transformation des op\u00e9rations mini\u00e8res", location: "Nouvelle-Cal\u00e9donie", sector: "Mines & Ressources",
        challenge: "Production inf\u00e9rieure \u00e0 50 % de la capacit\u00e9 nominale, avec une disponibilit\u00e9 des \u00e9quipements mobiles critiques \u00e0 55 % et des pertes significatives de r\u00e9cup\u00e9ration de nickel sur l\u2019ensemble de la cha\u00eene d\u2019extraction.",
        approach: ["Diagnostic de plus de 50 points de risque sur l\u2019ensemble de la cha\u00eene d\u2019extraction", "Programme de s\u00e9curisation du minerai structur\u00e9 autour de 13 projets d\u2019am\u00e9lioration", "D\u00e9ploiement du MOS avec des rituels de performance quotidiens, hebdomadaires et mensuels", "R\u00e9vision de la fiabilit\u00e9 des \u00e9quipements en partenariat avec Caterpillar & Komatsu"],
        metrics: [{ value: "+25%", label: "Performance d\u2019extraction en 8 mois" }, { value: "75%", label: "Disponibilit\u00e9 des \u00e9quipements atteinte" }, { value: "\u20ac25M+", label: "Valeur de nickel r\u00e9cup\u00e9r\u00e9e par an" }],
      },
      {
        project: "Programme d\u2019Excellence Op\u00e9rationnelle", location: "Maroc", sector: "Acier & M\u00e9taux",
        challenge: "La plus grande aci\u00e9rie du Maroc devait r\u00e9duire ses co\u00fbts de 300 DH/t, standardiser ses proc\u00e9d\u00e9s m\u00e9tallurgiques et renforcer sa comp\u00e9titivit\u00e9 avant la suppression des barri\u00e8res douani\u00e8res, dans un d\u00e9lai de 24 mois.",
        approach: ["Programme \u00e0 double volet : standardisation des proc\u00e9d\u00e9s + am\u00e9lioration de la performance", "Application des m\u00e9thodologies Lean Manufacturing, Six Sigma et SMED", "Construction du MOS et du cadre KPI, du terrain jusqu\u2019au comit\u00e9 de direction", "Programme de mont\u00e9e en comp\u00e9tences des superviseurs et collaboration transversale"],
        metrics: [{ value: "300 DH/t", label: "R\u00e9duction des co\u00fbts atteinte" }, { value: "24 mois", label: "Feuille de route de transformation" }, { value: "N\u00b01", label: "Plus grande aci\u00e9rie du Maroc" }],
      },
      {
        project: "Transformation Organisationnelle & Conduite du Changement", location: "Europe", sector: "Acier & Industrie",
        challenge: "Un grand producteur d\u2019acier devait passer d\u2019une culture de moyens \u00e0 une organisation orient\u00e9e r\u00e9sultats. Les \u00e9quipes manquaient de visibilit\u00e9 sur les objectifs et les indicateurs cl\u00e9s, la collaboration transversale \u00e9tait faible et la responsabilisation diffuse \u00e0 travers les niveaux hi\u00e9rarchiques.",
        approach: ["Diagnostic complet et d\u00e9finition de la vision cible avec les \u00e9quipes de direction et op\u00e9rationnelles", "Programme structur\u00e9 de conduite du changement avec ancrage de nouveaux rythmes de management", "Cadre KPI et reporting de performance standardis\u00e9s du terrain jusqu\u2019au comit\u00e9 de direction", "Programme de formation transversal pour renforcer l\u2019appropriation, la responsabilisation et l\u2019orientation action"],
        metrics: [{ value: "100%", label: "\u00c9quipes align\u00e9es sur KPIs et priorit\u00e9s" }, { value: "R\u00e9sultats", label: "Passage d\u2019une logique de moyens \u00e0 une logique de r\u00e9sultat" }, { value: "Durable", label: "Cadre de gouvernance ancr\u00e9" }],
      },
    ],
  },
  testimonials: {
    label: "T\u00e9moignages Clients",
    heading: "Ce que disent nos clients",
    items: [
      { quote: "Advaltis Consulting a jou\u00e9 un r\u00f4le d\u00e9terminant dans la transformation de notre performance op\u00e9rationnelle \u00e0 Koniambo Nickel. Leur approche structur\u00e9e des syst\u00e8mes de management op\u00e9rationnel et leur leadership de terrain nous ont permis de r\u00e9aliser des am\u00e9liorations significatives en productivit\u00e9, discipline des co\u00fbts et s\u00e9curit\u00e9 sur l\u2019ensemble de nos op\u00e9rations mini\u00e8res et de traitement.", author: "Jason Dunwoody", company: "VP Mining, Glencore Koniambo Nickel", sector: "Mines & M\u00e9taux" },
      { quote: "Advaltis a apport\u00e9 une m\u00e9thodologie rigoureuse et pragmatique \u00e0 notre programme d\u2019excellence op\u00e9rationnelle. Leur capacit\u00e9 \u00e0 mobiliser nos \u00e9quipes \u00e0 tous les niveaux, des op\u00e9rateurs en usine \u00e0 la direction g\u00e9n\u00e9rale, a \u00e9t\u00e9 cl\u00e9 pour obtenir des gains mesurables en efficacit\u00e9 et ancrer une culture durable d\u2019am\u00e9lioration continue dans nos usines.", author: "JC Trontin", company: "Directeur, APERAM", sector: "Acier & Inox" },
      { quote: "Collaborer avec Advaltis Consulting a marqu\u00e9 un v\u00e9ritable point d\u2019inflexion pour notre BU. Leur accompagnement nous a permis de repenser en profondeur nos processus op\u00e9rationnels, de renforcer la coordination interfonctionnelle et de d\u00e9ployer des dispositifs de pilotage de la performance g\u00e9n\u00e9rateurs de r\u00e9sultats concrets. Leur approche se distingue par un \u00e9quilibre rare entre vision strat\u00e9gique et pragmatisme op\u00e9rationnel.", author: "Hicham Ouassit", company: "Directeur BU EVM, Ingelec", sector: "\u00c9quipement \u00c9lectrique" },
    ],
  },
  contact: {
    label: "Contactez-nous",
    heading: "Engageons la",
    headingAccent: "conversation",
    desc: "Que vous fassiez face \u00e0 des d\u00e9fis op\u00e9rationnels, que vous planifiiez une transformation num\u00e9rique ou que vous recherchiez un partenaire strat\u00e9gique pour conduire le changement, nous sommes ouverts \u00e0 un premier \u00e9change. Sans engagement.",
    officeLabel: "Bureau",
    address: ["124 City Road", "Londres, EC1V 2NX, Royaume-Uni"],
    emailLabel: "Email",
    phoneLabel: "T\u00e9l\u00e9phone",
    formName: "Nom complet *",
    formNamePh: "Votre nom",
    formEmail: "Adresse email *",
    formEmailPh: "votre@email.com",
    formCompany: "Entreprise / Organisation",
    formCompanyPh: "Nom de votre entreprise",
    formMessage: "Message *",
    formMessagePh: "D\u00e9crivez votre d\u00e9fi ou votre demande...",
    successTitle: "Merci",
    success: "Merci, nous vous recontacterons dans les plus brefs d\u00e9lais.",
    error: "Une erreur est survenue. Veuillez r\u00e9essayer ou nous \u00e9crire directement \u00e0 info@advaltis.com",
    sending: "Envoi en cours...",
    submit: "Envoyer le message",
  },
  footer: {
    desc: "Une performance durable pour les leaders industriels mondiaux.",
    navLabel: "Navigation",
    contactLabel: "Contact",
    address: ["124 City Road", "Londres, EC1V 2NX, Royaume-Uni"],
    copyright: "Advaltis Consulting Ltd. Tous droits r\u00e9serv\u00e9s.",
    location: "Londres, Royaume-Uni",
  },
  methodology: {
    label: "Notre Approche",
    heading: "Cadre M\u00e9thodologique de",
    headingAccent: "Transformation Organisationnelle",
    desc: "Ce cadre est applicable \u00e0 tout secteur et toute taille d\u2019organisation. Les cinq phases restent constantes ; ce qui varie, c\u2019est le contenu des ateliers, la nature des KPIs et le p\u00e9rim\u00e8tre fonctionnel concern\u00e9.",
    phases: [
      {
        phase: "01",
        title: "Diagnostic & \u00c9tat des Lieux",
        desc: "Analyse syst\u00e9matique de la situation de d\u00e9part : cartographie des forces, faiblesses, dysfonctionnements et opportunit\u00e9s sur l\u2019ensemble des fonctions.",
        points: [
          "Identification des \u00e9carts entre la performance actuelle et les ambitions d\u00e9finies",
          "Mise en place d\u2019indicateurs de r\u00e9f\u00e9rence (baseline KPIs) par domaine fonctionnel",
        ],
      },
      {
        phase: "02",
        title: "D\u00e9finition de la Vision Cible",
        desc: "Formalisation d\u2019une vision, mission et valeurs partag\u00e9es (MVV). D\u00e9clinaison en piliers strat\u00e9giques op\u00e9rationnels.",
        points: [
          "Traduction de la vision en objectifs quantifiables",
          "Jalons temporels clairs : court, moyen et long terme",
        ],
      },
      {
        phase: "03",
        title: "Co-construction des Plans d\u2019Action",
        desc: "Organisation d\u2019ateliers multi-fonctions pour g\u00e9n\u00e9rer des actions concr\u00e8tes, prioris\u00e9es et attribu\u00e9es.",
        points: [
          "Travail en mode participatif pour assurer l\u2019adh\u00e9sion des \u00e9quipes",
          "Coordination inter-entit\u00e9s et partage d\u2019information",
        ],
      },
      {
        phase: "04",
        title: "Pilotage & Outillage",
        desc: "D\u00e9ploiement des outils de suivi adapt\u00e9s : reporting, CRM, tableaux de bord, syst\u00e8mes digitaux.",
        points: [
          "Formalisation et standardisation des processus cl\u00e9s",
          "R\u00e9unions structur\u00e9es avec comptes rendus et actions assign\u00e9es",
        ],
      },
      {
        phase: "05",
        title: "Am\u00e9lioration Continue & Gouvernance",
        desc: "Application d\u2019un cycle PDCA sur chaque initiative majeure. \u00c9valuation r\u00e9guli\u00e8re des r\u00e9sultats vs objectifs.",
        points: [
          "Ajustements bas\u00e9s sur le terrain et les retours d\u2019exp\u00e9rience",
          "Gouvernance formalis\u00e9e garantissant la p\u00e9rennit\u00e9 de la d\u00e9marche",
        ],
      },
    ],
    leadMagnet: {
      heading: "T\u00e9l\u00e9chargez le cadre complet",
      desc: "Obtenez notre guide d\u00e9taill\u00e9 du Cadre de Transformation Organisationnelle en 5 phases. Entrez votre email pour acc\u00e9der au t\u00e9l\u00e9chargement.",
      placeholder: "Votre adresse email",
      cta: "T\u00e9l\u00e9charger le PDF",
      success: "Merci ! Votre document est pr\u00eat.",
      error: "Une erreur est survenue. Veuillez r\u00e9essayer.",
      sending: "Envoi en cours...",
      downloadNow: "Appuyez pour t\u00e9l\u00e9charger",
    },
  },
  deepmeta: {
    label: "Partenariat Strat\u00e9gique",
    badge: "Advaltis \u00d7 DeepMeta",
    heading: "L\u2019IA au Service d\u2019un Acier",
    headingAccent: "Plus Intelligent, Plus Vert, Plus Comp\u00e9titif",
    subtitle: "DeepMeta aide les aci\u00e9ristes \u00e0 transformer leurs donn\u00e9es op\u00e9rationnelles et de d\u00e9veloppement durable en intelligence actionnable, pour de meilleures d\u00e9cisions, moins d\u2019\u00e9missions, une efficacit\u00e9 accrue et une performance commerciale renforc\u00e9e.",
    body1: "Les producteurs d\u2019acier font face \u00e0 une pression croissante pour r\u00e9duire leurs \u00e9missions carbone, g\u00e9rer la volatilit\u00e9 \u00e9nerg\u00e9tique et des mati\u00e8res premi\u00e8res, am\u00e9liorer leur performance op\u00e9rationnelle et r\u00e9pondre aux exigences de transparence de leurs clients. Ces d\u00e9fis sont interconnect\u00e9s et ne peuvent pas \u00eatre r\u00e9solus avec des donn\u00e9es fragment\u00e9es ou des outils isol\u00e9s.",
    body2: "DeepMeta place l\u2019IA au c\u0153ur de la prise de d\u00e9cision sid\u00e9rurgique. En connectant les donn\u00e9es de production, d\u2019\u00e9nergie, d\u2019\u00e9missions et d\u2019activit\u00e9, DeepMeta permet aux aci\u00e9ristes d\u2019identifier les inefficacit\u00e9s, d\u2019am\u00e9liorer la performance des processus, de renforcer la visibilit\u00e9 sur les \u00e9missions et d\u2019agir plus rapidement avec confiance.",
    body3: "Ce n\u2019est pas de l\u2019IA exp\u00e9rimentale. C\u2019est une IA con\u00e7ue pour g\u00e9n\u00e9rer une valeur mesurable sur l\u2019ensemble de la cha\u00eene de valeur sid\u00e9rurgique, en soutenant la r\u00e9duction des co\u00fbts, la r\u00e9silience op\u00e9rationnelle, la performance environnementale et la diff\u00e9renciation concurrentielle.",
    roleNote: "DeepMeta\u2019s AI is fundamentally a means to achieve operational excellence - accelerating and streamlining processes while eliminating unnecessary costs that have traditionally relied on human experience alone. The approach starts with identifying the specific operational excellence issues and pain points that customers face. This diagnostic-first philosophy ensures that AI delivers targeted, measurable value from day one.",
    valuePoints: [
      { title: "Optimiser la performance", desc: "Am\u00e9liorer l\u2019efficacit\u00e9 des processus, r\u00e9duire les d\u00e9chets et r\u00e9v\u00e9ler les pertes op\u00e9rationnelles cach\u00e9es." },
      { title: "Renforcer la durabilit\u00e9", desc: "Am\u00e9liorer le suivi des \u00e9missions, soutenir la d\u00e9carbonation et accro\u00eetre la transparence op\u00e9rationnelle." },
      { title: "Am\u00e9liorer la prise de d\u00e9cision", desc: "Connecter les donn\u00e9es cloisonn\u00e9es de production, d\u2019\u00e9nergie et m\u00e9tier pour des actions plus rapides et plus pertinentes." },
      { title: "Cr\u00e9er un avantage concurrentiel", desc: "Transformer l\u2019intelligence op\u00e9rationnelle et environnementale en valeur client et en performance commerciale." },
    ],
    ctaPrimary: "D\u00e9couvrir les solutions DeepMeta",
    ctaSecondary: "Parler \u00e0 notre \u00e9quipe",
  },
  blogPreview: {
    heading: "Derni\u00e8res Perspectives",
    viewAll: "Voir tous les articles",
  },
  blog: {
    label: "Insights",
    heading: "Perspectives & R\u00e9flexions",
    desc: "Analyses, retours d\u2019exp\u00e9rience et points de vue sur la transformation op\u00e9rationnelle, l\u2019IA industrielle et le leadership du changement.",
    backLabel: "Retour au Blog",
    articles: frArticles,
  },
  newsletter: {
    heading: "Restez inform\u00e9",
    desc: "Recevez nos analyses et points de vue sur la transformation op\u00e9rationnelle, l\u2019IA industrielle et le leadership du changement.",
    placeholder: "Votre adresse email",
    cta: "S\u2019abonner",
    sending: "Envoi...",
    success: "Merci ! Vous \u00eates inscrit.",
    alreadySubscribed: "Vous \u00eates d\u00e9j\u00e0 inscrit.",
    error: "Une erreur est survenue. Veuillez r\u00e9essayer.",
  },
  cookie: {
    message: "Ce site utilise des cookies pour am\u00e9liorer votre exp\u00e9rience de navigation. En continuant, vous acceptez notre utilisation des cookies.",
    accept: "Accepter tout",
    decline: "Refuser",
    customize: "Personnaliser",
    essentialLabel: "Essentiels",
    essentialDesc: "N\u00e9cessaires au fonctionnement du site",
    analyticsLabel: "Analytiques",
    analyticsDesc: "Nous aident \u00e0 comprendre comment vous utilisez le site",
    savePrefs: "Enregistrer mes pr\u00e9f\u00e9rences",
  },
  meta: {
    title: "Advaltis Consulting | Une performance durable pour les leaders industriels mondiaux",
    description: "Advaltis Consulting, Transformation op\u00e9rationnelle, innovation num\u00e9rique et ex\u00e9cution strat\u00e9gique pour les leaders industriels mondiaux.",
  },
};

export const en = {
  video: {
    label: "Our Vision",
    heading: "Transforming heavy industry into high-performing, sustainable organisations.",
    pause: "Pause",
    play: "Play",
  },
  nav: {
    links: [
      { label: "Services", id: "services" },
      { label: "Approach", id: "methodology" },
      { label: "Results", id: "results" },
      { label: "About", id: "about" },
      { label: "AI", id: "ai-transformation" },
      { label: "Contact", id: "contact" },
    ],
    bookCall: "Book a Discovery Call",
  },
  hero: {
    est: "Est. 2010, London, UK",
    h1: ["Transforming ", "Industrial", "Operations", " Into", "Lasting Results"],
    tagline: "Driving Operational Excellence through Digital Transformation",
    subtitle: "We deliver results that last. Partnering with global industrial leaders to implement sustainable change across operations, digital systems, and organisational capability.",
    ctaExplore: "Explore Our Services",
    ctaBook: "Book a Discovery Call",
    trustClients: ["ArcelorMittal", "Glencore", "Aperam", "DHL", "Yamama Cement"],
    moreSectors: "& other industry leaders",
    scroll: "Scroll",
  },
  stats: [
    { value: "2010", label: "Year Founded", suffix: "" },
    { value: "20", label: "Years Delivering Impact", suffix: "+" },
    { value: "50", label: "Transformation Programmes", suffix: "+" },
    { value: "12", label: "Countries of Operation", suffix: "+" },
  ],
  services: {
    label: "What We Do",
    heading: "Seven Integrated Capability Areas",
    desc: "Combining deep industrial expertise, transformation consulting, and digital innovation, including a dedicated AI Transformation practice.",
    expandLabel: "Learn More",
    collapseLabel: "Show Less",
    items: [
      {
        title: "Operational Transformation & Performance Improvement", subtitle: "Operational Excellence",
        description: "Helping industrial organisations improve productivity, cost efficiency, and operational discipline through structured transformation programmes.",
        points: ["Management Operating Systems (MOS)", "KPI and performance management frameworks", "Operational excellence & continuous improvement", "Cost reduction & productivity improvement"],
      },
      {
        title: "Digital Transformation & AI Adoption", subtitle: "Digital & AI",
        description: "Supporting organisations in integrating digital technologies into operations and decision-making. Focus is on business value from technology, not technology for its own sake.",
        points: ["Identification of high-value automation opportunities", "AI-enabled process improvement", "Digital operating models", "Data-driven performance management"],
      },
      {
        title: "Strategy Execution & Transformation Leadership", subtitle: "Strategic Delivery",
        description: "Helping organisations translate strategy into structured, executable transformation programmes with clear governance and measurable outcomes.",
        points: ["Strategic transformation roadmaps", "Programme governance & delivery", "Cross-functional transformation leadership", "Change management at scale"],
      },
      {
        title: "Industrial Operations & Reliability Excellence", subtitle: "Industrial Expertise",
        description: "Specialised support for asset-intensive industries focused on OEE improvement, maintenance reliability, and production system optimisation.",
        points: ["OEE improvement programmes", "Maintenance reliability strategies", "Production system optimisation", "Operations management frameworks"],
      },
      {
        title: "Organisational Design & Leadership Enablement", subtitle: "People & Structure",
        description: "Ensuring organisations have the structure, capabilities, and leadership alignment required to sustain transformation and drive long-term performance.",
        points: ["Operating model design", "Leadership coaching & alignment", "Change leadership programmes", "Capability development"],
      },
      {
        title: "PMO & Governance", subtitle: "Programme Management",
        description: "Establishing robust programme management offices and governance frameworks to ensure transformation initiatives are delivered on time, on budget, and with full accountability.",
        points: ["PMO setup & structuring", "Governance frameworks & steering committees", "Portfolio prioritisation & resource allocation", "Risk management & performance reporting"],
      },
    ],
  },
  ai: {
    label: "Emerging Capability",
    heading: "AI Transformation &",
    headingAccent: "Change Leadership",
    intro: "Turn AI into a competitive advantage. We integrate custom AI solutions directly into your workflows to boost efficiency and drive smarter decision-making, building confidence across leadership teams and operational units while ensuring every initiative translates into measurable business outcomes.",
    approachIntro: "Combining strategic vision, operational expertise, and hands-on implementation, AI tools are embedded into everyday processes so your teams can work faster and make better decisions, while maintaining stable and efficient operations.",
    whyLabel: "Why this matters",
    whyPoints: [
      "Unlock significant value by identifying and delivering high-impact automation opportunities",
      "Accelerate adoption of modern AI tools that improve productivity and customer outcomes",
      "Lead transformation initiatives that enhance efficiency while maintaining operational stability",
    ],
    divider: "What We Deliver",
    deliverables: [
      { title: "Automation Opportunity Identification", body: "Your business processes are analysed to identify where automation and AI can generate the greatest impact, with initiatives prioritised based on value creation." },
      { title: "AI Proof-of-Concept Development", body: "Practical proof-of-concept use cases are designed and built to demonstrate the tangible benefits of AI and automation using clear performance metrics." },
      { title: "Cross-Functional Transformation Delivery", body: "Solutions are designed and implemented in close collaboration with your operations, technology, product, and customer teams to align with business objectives." },
      { title: "AI Adoption & Capability Building", body: "Your teams are supported through the adoption of AI tools with training, coaching, and hands-on implementation support." },
      { title: "End-to-End Transformation Leadership", body: "Complex change programmes are led end-to-end, ensuring alignment between strategy, execution, and operational performance." },
      { title: "Continuous Innovation & Optimisation", body: "Implementation progress is monitored, automation initiatives refined, and relevant developments in AI and digital technologies incorporated." },
    ],
  },
  about: {
    label: "The Founder",
    role: "Founder & Managing Director",
    bio1: "Dr. Jaoued Ahmed founded Advaltis in 2010. A Master Black Belt in Operational Excellence, with an Oxford PhD and INSEAD MBA, he has led large-scale transformation programmes across steel, mining, oil & gas, and technology sectors. Where engagements require additional expertise, he works with a select network of Senior Consulting Partners.",
    credentials: [
      { label: "PhD Materials Science", detail: "University of Oxford" },
      { label: "Executive MBA", detail: "INSEAD Business School" },
      { label: "Master Black Belt", detail: "Operational Excellence & Six Sigma" },
      { label: "International Expertise", detail: "Steel, Mining, Oil & Gas, Technology" },
      { label: "Founded Advaltis", detail: "2010, London, United Kingdom" },
    ],
    imageAlt: "Dr. Jaoued Ahmed, Founder, Advaltis Consulting",
    overlayLabel: "Advaltis Consulting, Est. 2010",
    overlayText: "20+ Years Transforming Industrial Organisations Globally",
    whyLabel: "Why Advaltis",
    whyHeading: "Industrial Depth.",
    whyHeadingAccent: "Boutique Commitment.",
    whyDesc: "Advaltis is not a traditional large consulting firm. We are a specialised partner that brings world-class expertise directly to your operations, with the focus and agility that large firms simply cannot offer.",
    whyCta: "Start a Conversation",
    whyItems: [
      { title: "Analytical Depth & Methodological Rigour", description: "A rare combination of PhD-level analytical depth, Master Black Belt expertise in Operational Excellence, and practical hands-on transformation experience across complex industrial environments." },
      { title: "Deep Industrial Expertise", description: "Not a generalist consultancy, Advaltis brings decades of focused expertise in steel, mining, oil & gas, and heavy manufacturing where the stakes are highest." },
      { title: "Measurable Business Impact", description: "Every engagement is structured around delivering quantifiable results. We define success metrics upfront and hold ourselves accountable to them." },
      { title: "Boutique. Senior. Committed.", description: "You work directly with Dr. Ahmed, not a team of junior associates. Where engagements demand additional depth or pace, he draws on a select network of Senior Consulting Partners." },
      { title: "Expert Consultancy Partnerships", description: "Advaltis works in strategic partnership with other leading specialist consultancies, bringing the right expertise, coordinated and quality-assured." },
    ],
  },
  clients: {
    header: "Trusted by Global Industry Leaders",
    sectors: ["Steel & Metals", "Mining & Resources", "Oil & Gas", "Cement & Materials", "Logistics & Supply Chain", "Heavy Industry", "Manufacturing", "Consulting"],
    items: [
      { name: "ArcelorMittal", sector: "Steel", logo: "/logos/arcelormittal.png" },
      { name: "Glencore", sector: "Mining", logo: "/logos/glencore.png" },
      { name: "Aperam", sector: "Steel", logo: "/logos/aperam.png" },
      { name: "Maghreb Steel", sector: "Steel" },
      { name: "Yamama Cement", sector: "Cement" },
      { name: "DHL", sector: "Logistics & Supply Chain", logo: "/logos/dhl.png" },
      { name: "North American Steel", sector: "Steel" },
      { name: "CMT", sector: "Mining" },
      { name: "Ingelec", sector: "Manufacturing" },
      { name: "Proudfoot", sector: "Consulting" },
      { name: "YCP Renoir", sector: "Consulting" },
      { name: "TNP Consultants", sector: "Consulting" },
      { name: "ATPERF Conseil", sector: "Partner" },
      { name: "MLK Conseil", sector: "Partner" },
      { name: "KAY Consulting", sector: "Partner" },
    ],
  },
  caseStudies: {
    label: "Client Engagements",
    heading: "Proven Impact Across",
    headingAccent: "Global Industry",
    desc: "From diagnostics to full transformation, every engagement is structured around measurable, lasting results.",
    challengeLabel: "The Challenge",
    approachLabel: "The Approach",
    methodology: [
      { phase: "01", label: "Diagnostic & Analysis", desc: "As-Is assessment, performance gap identification, quantification of improvement levers" },
      { phase: "02", label: "Target Design & Roadmap", desc: "To-Be definition, structured roadmap, prioritised project portfolio with clear ownership" },
      { phase: "03", label: "Programme Implementation", desc: "Hands-on delivery, MOS deployment, change enablement, performance tracking and steering" },
      { phase: "04", label: "Sustain & Transform", desc: "Capability building, performance anchoring and organisational transformation for lasting results" },
    ],
    items: [
      {
        project: "Mining Operations Transformation", location: "New Caledonia", sector: "Mining & Resources",
        challenge: "Production running at less than 50% of designed capacity, with critical mobile equipment availability at 55% and significant nickel recovery losses across the full extraction chain.",
        approach: ["Diagnostic of 50+ risk points across the full extraction chain", "Ore Assurance Programme structured across 13 improvement projects", "MOS deployment with daily, weekly and monthly performance rituals", "Equipment reliability overhaul in partnership with Caterpillar & Komatsu"],
        metrics: [{ value: "+25%", label: "Extraction performance in 8 months" }, { value: "75%", label: "Equipment availability achieved" }, { value: "\u20ac25M+", label: "Nickel value recovered annually" }],
      },
      {
        project: "Operational Excellence Programme", location: "Morocco", sector: "Steel & Metals",
        challenge: "Morocco\u2019s largest steel plant needed to reduce costs by 300 DH/t, standardise metallurgical processes, and build competitive resilience ahead of customs barrier removal, within a 24-month window.",
        approach: ["Dual-track programme: process standardisation + performance improvement", "Lean Manufacturing, 6 Sigma, and SMED methodologies applied", "MOS and KPI framework built from floor level to executive steering", "Supervisor capability programme and cross-functional collaboration design"],
        metrics: [{ value: "300 DH/t", label: "Cost reduction achieved" }, { value: "24 months", label: "Transformation roadmap" }, { value: "#1", label: "Largest steel plant in Morocco" }],
      },
      {
        project: "Organisational Transformation & Change Management", location: "Europe", sector: "Steel & Manufacturing",
        challenge: "A major steel producer needed to shift from a means-based culture to a results-driven organisation. Teams lacked visibility on objectives and KPIs, cross-functional collaboration was weak, and accountability was diffused across hierarchical levels.",
        approach: ["Full diagnostic and target vision definition with leadership and operational teams", "Structured change management programme embedding new management operating rhythms", "KPI framework and performance reporting standardised from shop floor to executive level", "Cross-functional training programme to build ownership, accountability and action-orientation"],
        metrics: [{ value: "100%", label: "Teams aligned on KPIs and priorities" }, { value: "Results", label: "Shift from means-based to results-driven culture" }, { value: "Sustained", label: "Governance framework embedded" }],
      },
    ],
  },
  testimonials: {
    label: "Client Perspectives",
    heading: "What Our Clients Say",
    items: [
      { quote: "Advaltis Consulting played a pivotal role in transforming our operational performance at Koniambo Nickel. Their structured approach to management operating systems and hands-on leadership on the ground helped us achieve significant improvements in productivity, cost discipline, and safety across our mining and processing operations.", author: "Jason Dunwoody", company: "VP Mining, Glencore Koniambo Nickel", sector: "Mining & Metals" },
      { quote: "Advaltis brought a rigorous and pragmatic methodology to our operational excellence programme. Their ability to engage our teams at every level, from shop-floor operators to senior management, was key in delivering measurable gains in efficiency and embedding a lasting culture of continuous improvement across our plants.", author: "JC Trontin", company: "Directeur, APERAM", sector: "Steel & Stainless" },
      { quote: "Collaborating with Advaltis Consulting marked a genuine turning point for our BU. Their support enabled us to fundamentally rethink our operational processes, strengthen cross-functional coordination, and deploy performance management systems that delivered concrete results. Their approach stands out for its rare balance between strategic vision and operational pragmatism.", author: "Hicham Ouassit", company: "Directeur BU EVM, Ingelec", sector: "Electrical Equipment" },
    ],
  },
  contact: {
    label: "Get in Touch",
    heading: "Start a Discovery",
    headingAccent: "Conversation",
    desc: "Whether you are facing operational challenges, planning a digital transformation, or seeking a strategic partner to drive change, we welcome an initial conversation. No commitment required.",
    officeLabel: "Office",
    address: ["124 City Road", "London, EC1V 2NX, United Kingdom"],
    emailLabel: "Email",
    phoneLabel: "Phone",
    formName: "Full Name *",
    formNamePh: "Your name",
    formEmail: "Email Address *",
    formEmailPh: "your@email.com",
    formCompany: "Company / Organisation",
    formCompanyPh: "Your company name",
    formMessage: "Message *",
    formMessagePh: "Tell us about your challenge or enquiry...",
    successTitle: "Thank You",
    success: "Thank you, we will be in touch shortly.",
    error: "Something went wrong. Please try again or email us directly at info@advaltis.com",
    sending: "Sending...",
    submit: "Send Message",
  },
  footer: {
    desc: "Delivering Sustainable Performance for Global Industrial Leaders.",
    navLabel: "Navigation",
    contactLabel: "Contact",
    address: ["124 City Road", "London, EC1V 2NX, UK"],
    copyright: "Advaltis Consulting Ltd. All rights reserved.",
    location: "London, United Kingdom",
  },
  methodology: {
    label: "Our Approach",
    heading: "Organisational",
    headingAccent: "Transformation Framework",
    desc: "This framework is applicable to any sector and any size of organisation. The five phases remain constant; what varies is the content of the workshops, the nature of the KPIs and the functional scope involved.",
    phases: [
      {
        phase: "01",
        title: "Diagnostic & Current State Assessment",
        desc: "Systematic analysis of the starting position: mapping strengths, weaknesses, dysfunctions and opportunities across all functions.",
        points: [
          "Identification of gaps between current performance and defined ambitions",
          "Establishment of baseline KPIs by functional area",
        ],
      },
      {
        phase: "02",
        title: "Target Vision Definition",
        desc: "Formalisation of a shared vision, mission and values (VMV). Translated into operational strategic pillars.",
        points: [
          "Vision translated into quantifiable objectives",
          "Clear milestones: short, medium and long term",
        ],
      },
      {
        phase: "03",
        title: "Co-construction of Action Plans",
        desc: "Cross-functional workshops to generate concrete, prioritised and assigned actions.",
        points: [
          "Participative approach to ensure team buy-in",
          "Inter-entity coordination and information sharing",
        ],
      },
      {
        phase: "04",
        title: "Steering & Tooling",
        desc: "Deployment of fit-for-purpose tracking tools: reporting, CRM, dashboards, digital systems.",
        points: [
          "Formalisation and standardisation of key processes",
          "Structured meeting rhythm with minutes and assigned actions",
        ],
      },
      {
        phase: "05",
        title: "Continuous Improvement & Governance",
        desc: "Application of a PDCA cycle on each major initiative. Regular evaluation of results against objectives.",
        points: [
          "Field-based adjustments and lessons learned",
          "Formalised governance ensuring long-term sustainability of the approach",
        ],
      },
    ],
    leadMagnet: {
      heading: "Download the Full Framework",
      desc: "Get our detailed 5-phase Organisational Transformation Framework guide. Enter your email to unlock the download.",
      placeholder: "Your email address",
      cta: "Download the PDF",
      success: "Thank you! Your download is ready.",
      error: "Something went wrong. Please try again.",
      sending: "Sending...",
      downloadNow: "Tap to Download PDF",
    },
  },
  deepmeta: {
    label: "Strategic Partnership",
    badge: "Advaltis \u00d7 DeepMeta",
    heading: "AI for Smarter, Greener,",
    headingAccent: "More Competitive Steel",
    subtitle: "DeepMeta helps steel companies transform operational and sustainability data into actionable intelligence, enabling better decisions, lower emissions, improved efficiency, and stronger commercial performance.",
    body1: "Steel producers face growing pressure to reduce carbon emissions, manage energy and raw material volatility, improve operational performance, and meet rising customer expectations for transparency. These challenges are interconnected, and they cannot be solved with fragmented data or isolated tools.",
    body2: "DeepMeta brings AI into the heart of steelmaking decision-making. By connecting production, energy, emissions, and business data, DeepMeta enables steel companies to identify inefficiencies, improve process performance, strengthen emissions visibility, and act faster with confidence.",
    body3: "This is not AI for experimentation. It is AI designed to deliver measurable value across the steel value chain, supporting cost reduction, operational resilience, sustainability performance, and competitive differentiation.",
    roleNote: "DeepMeta's AI is fundamentally a means to achieve operational excellence - accelerating and streamlining processes while eliminating unnecessary costs that have traditionally relied on human experience alone. The approach starts with identifying the specific operational excellence issues and pain points that customers face. This diagnostic-first philosophy ensures that AI delivers targeted, measurable value from day one.",
    valuePoints: [
      { title: "Optimize Performance", desc: "Improve process efficiency, reduce waste, and uncover hidden operational losses." },
      { title: "Strengthen Sustainability", desc: "Enhance emissions tracking, support decarbonization efforts, and increase transparency across operations." },
      { title: "Improve Decision-Making", desc: "Connect siloed data across production, energy, and business functions to enable faster, smarter action." },
      { title: "Create Competitive Advantage", desc: "Turn operational and sustainability intelligence into stronger customer value and business performance." },
    ],
    ctaPrimary: "Explore DeepMeta Solutions",
    ctaSecondary: "Talk to Our Team",
  },
  blogPreview: {
    heading: "Latest Insights",
    viewAll: "View All Articles",
  },
  blog: {
    label: "Insights",
    heading: "Perspectives & Thought Leadership",
    desc: "Analysis, field experience and viewpoints on operational transformation, industrial AI, and change leadership.",
    backLabel: "Back to Blog",
    articles: enArticles,
  },
  newsletter: {
    heading: "Stay Informed",
    desc: "Receive our analysis and perspectives on operational transformation, industrial AI, and change leadership.",
    placeholder: "Your email address",
    cta: "Subscribe",
    sending: "Sending...",
    success: "Thank you! You are now subscribed.",
    alreadySubscribed: "You are already subscribed.",
    error: "Something went wrong. Please try again.",
  },
  cookie: {
    message: "This website uses cookies to enhance your browsing experience. By continuing, you agree to our use of cookies.",
    accept: "Accept All",
    decline: "Decline",
    customize: "Customize",
    essentialLabel: "Essential",
    essentialDesc: "Required for the site to function",
    analyticsLabel: "Analytics",
    analyticsDesc: "Help us understand how you use the site",
    savePrefs: "Save Preferences",
  },
  meta: {
    title: "Advaltis Consulting | Delivering Sustainable Performance for Global Industrial Leaders",
    description: "Advaltis Consulting, Operational Transformation, Digital Innovation and Strategy Execution for global industrial leaders.",
  },
};
